module.exports = __webpack_public_path__ + "img/kz.a19240f6.svg";